import React from "react";
import { useHistory } from "react-router-dom";
import LottieAnimation from "../Common/Lottie";

import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";

const useStyles = makeStyles(() => ({
  content: {
    maxWidth: "50%",
  },
  card: {
    boxShadow: "0 4px 4px 0 rgba(0,0,0,0.1)",
    display: "flex",
    alignItems: "center",
  },
}));

const StyledCard = ({ title, subtitle, path, animation }) => {
  const classes = useStyles();
  const history = useHistory();
  const handleClick = () => {
    history.push(path);
  };

  return (
    <Card
      variant="outlined"
      className={classes.card}
      onClick={() => handleClick()}
    >
      <LottieAnimation lotti={animation} height={120} width={120} />
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <Typography component="h6">{title}</Typography>
          <Typography variant="body2" color="textSecondary">
            {subtitle}
          </Typography>
        </CardContent>
      </div>
    </Card>
  );
};

export default StyledCard;
